module.exports = __webpack_public_path__ + "static/media/image5.ab70a89c.jpg";